import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';

import * as c from './config';
import router from './router';
import store from './store';
import {IntlProvider} from 'react-intl';

function loadFeatureSource(key, url) {
	return $.ajax({dataType: 'json', url: url})
		.done((data) => {
			store.dispatch({
				type: 'ADD_FEATURE_SOURCE',
				key: key,
				data: data,
			});
		})
		.fail((...args) => {
			console.error('Failed to load GeoJSON!', args);
		});
}

const urls = {
	[c.FEATURE_SOURCE_ALL]:
		Number(window.location.port) >= 1000
			? new URL('../testdata.geojson', import.meta.url).toString()
			: '/apps/kulturnacht2025/php/data-proxy.php',
};

const ajaxRequestPromises = Object.keys(urls).map((key) =>
	loadFeatureSource(key, urls[key])
);
$.when(...ajaxRequestPromises).then(() => {
	ReactDOM.render(
		<IntlProvider locale="de-DE">
			<Provider store={store} children={router} />
		</IntlProvider>,
		document.getElementById('app')
	);
});

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @neonaut/no-restricted-global-extend
window.store = store;
